import React from 'react';

import Overview from '../Category/Overview/Overview';
import Subcategory from '../Subcategory/Subcategory';

import './TopLevelCategoryOverview.scss';

const TopLevelCategoryOverview = ({
  selectedCategory,
  subcategories,
  onChange,
}) => {
  return (
    <>
      <Overview
        category={selectedCategory}
        onScoreChange={(newValue) =>
          onChange(selectedCategory.categoryId, { value: newValue })
        }
        onDescriptionChange={(newDescription) =>
          onChange(selectedCategory.categoryId, { description: newDescription })
        }
      />
      <div className="category-content">
        {subcategories.map((sub) => (
          <Subcategory
            key={sub.categoryId}
            subcategory={sub}
            onScoreChange={(newValue) =>
              onChange(sub.categoryId, { value: newValue })
            }
            onDescriptionChange={(newDescription) =>
              onChange(sub.categoryId, { description: newDescription })
            }
          />
        ))}
      </div>
    </>
  );
};

export default TopLevelCategoryOverview;
